/** Préférences locales de confort (foyer affiché…). Le stockage peut être indisponible : jamais bloquant. */
export function readLocal(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writeLocal(key: string, value: string) {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    /* stockage indisponible (navigation privée…) : on continue sans */
  }
}
